import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsFieldSchemeSelfConversionRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-scheme-self-conversion',
	path: '/jira/settings/issues/field-configuration/enable-field-scheme',
	exact: true,
};
